import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useContractGlobalSettingsStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        content: {
            marginLeft: 2,
            marginRight: 2,
        },
        sectionContent: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
        },
        explanation: {
            fontSize: theme.typography.pxToRem(14),
            fontWeight: 400,
            color: theme.palette.primary.dark,
            margin: 0,
            paddingLeft: theme.spacing(2.5),
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(1),
        },
        toggleRow: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: theme.spacing(2),
        },
    });
};
